import { TimeZones } from '../../../../types'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'
import { FilterValue, applySearchParams, urlToPathnameAndSearch } from '../utils'

type TimeZoneFilter = 'country_code' | 'search'
type TimeZoneFilters = Record<TimeZoneFilter, FilterValue>

const pathname = `/api/${apiVersion}/time-zones`

const defaults: TimeZoneFilters = {
  country_code: '',
  search: '',
}

const makeGetTimeZones =
  (baseUrl: string, config: HttpClientConfig) =>
  async (filters: TimeZoneFilters): Promise<TimeZones> => {
    const actualFilters = {
      ...defaults,
      ...filters,
    }

    const url = new URL(pathname, baseUrl)

    applySearchParams(url, actualFilters)

    const pathnameAndSearch = urlToPathnameAndSearch(url)
    const { data } = await service(baseUrl).get<TimeZones>(pathnameAndSearch, config)

    return data
  }

export { makeGetTimeZones }
export type { TimeZoneFilters }
